export default __webpack_public_path__ + "static/media/B3.3a4aaf1a.mp3";